<template>
  <div class="wrap">

    <Head @type="goSkill($event)" />
    <div class="part1">
      <p class="tit">恒为信息科技</p>
      <p class="txt">打造区块链技术生态，助力全球产业安全高效</p>

    </div>

    <div
      class="part2"
      id="skill"
    >
      <p class="tit1">领先的区块链技术</p>
      <div class="item">
        <div class="image">
          <img
            src="../../assets/images/mobile/home/part2-1.png"
            alt
          />
        </div>
        <p class="p1">共识算法</p>
        <p class="p2">自主研发的HCP共识算法，具有更高的并发和容错能力</p>
      </div>
      <div class="item">
        <div class="image">
          <img
            src="../../assets/images/mobile/home/part2-2.png"
            alt
          />
        </div>
        <p class="p1">加密算法</p>
        <p class="p2">支持secp256k1、ed25519、sm2p256v1(国密)</p>
      </div>
      <div class="item">
        <div class="image">
          <img
            src="../../assets/images/mobile/home/part2-3.png"
            alt
          />
        </div>
        <p class="p1">多链融合</p>
        <p class="p2">一键式区块链底层平台扩展</p>
      </div>
      <div class="item">
        <div class="image">
          <img
            src="../../assets/images/mobile/home/part2-4.png"
            alt
          />
        </div>
        <p class="p1">智能合约</p>
        <p class="p2">图灵完备的智能合约语言，高效易用</p>
      </div>
      <div class="item">
        <div class="image">
          <img
            src="../../assets/images/mobile/home/part2-5.png"
            alt
          />
        </div>
        <p class="p1">文件上链</p>
        <p class="p2">深度融合IPFS实现文件的链上存储</p>
      </div>
      <div class="item">
        <div class="image">
          <img
            src="../../assets/images/mobile/home/part2-6.png"
            alt
          />
        </div>
        <p class="p1">资产数字化</p>
        <p class="p2">支持同质化(Token)和非同质化数字资产(NFToken)</p>
      </div>
      <div class="item">
        <div class="image">
          <img
            src="../../assets/images/mobile/home/part2-7.png"
            alt
          />
        </div>
        <p class="p1">去中心化交易</p>
        <p class="p2">实现整个区块链生态内数字资产的去中心化撮合交易</p>
      </div>
      <div class="item">
        <div class="image">
          <img
            src="../../assets/images/mobile/home/part2-8.png"
            alt
          />
        </div>
        <p class="p1">跨链服务</p>
        <p class="p2">与其他区块链之间实现价值互通</p>
      </div>

      <div class="item">
        <div class="image">
          <img
            src="../../assets/images/mobile/home/part2-9.png"
            alt
          />
        </div>
        <p class="p1">身份索引</p>
        <p class="p2">赋予区块链身份真实世界的ID</p>
      </div>
      <div class="item">
        <div class="image">
          <img
            src="../../assets/images/mobile/home/part2-10.png"
            alt
          />
        </div>
        <p class="p1">黑名单机制法</p>
        <p class="p2">禁止区块链黑名单账户参与链上的任何交易</p>
      </div>

    </div>

    <div class="part3">
      <p class="tit1">成熟的区块链产品</p>
      <img
        class="bg"
        src="../../assets/images/mobile/home/part3-bg.png"
        alt=""
      >
      <div class="swip">
        <van-swipe indicator-color="white">
          <van-swipe-item>
            <div class="card">
              <div class="image">
                <img
                  src="../../assets/images/mobile/home/part3-1.png"
                  alt
                />
              </div>
              <div class="centent">
                <p class="title">底层核心平台</p>
                <p class="line ">
                  恒为区块链底层核心平台由恒为信息科技自主研发。平台功能多元化，性能优越，支持国密算法，可根据不同行业对区块链平台的要求，通过模块化和参数化的配置方式为具体的行业快速定制一个专属的区块链平台。
                </p>
                <div
                  class="but"
                  @click="$router.push('/mobile/product/platform')"
                >
                  <span>咨询我们</span>
                </div>

              </div>
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="card">
              <div class="image">
                <img
                  src="../../assets/images/mobile/home/part3-3.png"
                  alt
                />
              </div>
              <div class="centent">
                <p class="title">开发者平台</p>
                <p class="line ">
                  区块链开发者可以通过开发者平台学习和接入恒为链。平台提供了完整的API和参考示例，帮助开发快速接入并使用恒为链提供的区块链服务。
                </p>
                <div
                  class="but"
                  @click="window.open('https://developers.hwelltech.com/')"
                >
                  <span>咨询我们</span>
                </div>

              </div>
            </div>
          </van-swipe-item>
          <!-- <van-swipe-item>
            <div class="card">
              <div class="image">
                <img
                  src="../../assets/images/mobile/home/part3-1.png"
                  alt
                />
              </div>
              <div class="centent">
                <p class="title">恒为链</p>
                <p class="line ">
                  提供高品质企业级区块链服务，采用六层系统架构。
                </p>
                <p class="line">
                  支持NFToken的发行，实现不同类型资产的数字化；不仅支持文字的上链，还融合IPFS实现文件的上链存储；合约编写、部署、执行简单，执行过程可跟踪；实现恒为链与其他区块链之间价值和信息的互通。
                </p>
                <div class="but">
                  <span>咨询我们</span>
                </div>

              </div>
            </div>
          </van-swipe-item> -->
          <van-swipe-item>
            <div class="card">
              <div class="image">
                <img
                  src="../../assets/images/mobile/home/part3-4.png"
                  alt
                />
              </div>
              <div class="centent">
                <p class="title">Co-Chain</p>
                <p class="line ">
                  Co-Chain是基于SDChain开源底层核心平台，扩展出来具有同等功能的全新区块链平台。
                </p>
                <div
                  class="but"
                  @click="$router.push('/mobile/product/CoChain')"
                >
                  <span>咨询我们</span>
                </div>

              </div>
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="card">
              <div class="image">
                <img
                  src="../../assets/images/mobile/home/part3-5.png"
                  alt
                />
              </div>
              <div class="centent">
                <p class="title">Data API</p>
                <p class="line ">
                  Data API是一个高性能的区块链账本查询服务，通过将链式的区块链账本进行归集存储后，为应用层提供高性能的账本查询和账本数据统计服务。
                </p>
                <div
                  class="but"
                  @click="$router.push('/mobile/product/DataAPI')"
                >
                  <span>咨询我们</span>
                </div>

              </div>
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="card">
              <div class="image">
                <img
                  src="../../assets/images/mobile/home/part3-6.png"
                  alt
                />
              </div>
              <div class="centent">
                <p class="title">恒为BaaS平台</p>
                <p class="line ">
                  恒为BaaS平台将区块链技术云服务化，大大降低了区块链的使用难度和成本。平台提供了众多成熟的区块链组件和解决方案。通过完善、易用的区块链组件，帮助用户高效地接入和使用区块链，让用户更专注于解决核心业务问题。</p>
                <div
                  class="but"
                  @click="$router.push('/mobile/product/baas')"
                >
                  <span>咨询我们</span>
                </div>

              </div>
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="card">
              <div class="image">
                <img
                  src="../../assets/images/mobile/home/part3-7.png"
                  alt
                />
              </div>
              <div class="centent">
                <p class="title">区块链浏览器</p>
                <p class="line ">
                  恒为区块浏览器是恒为链的可视化的账本查询工具，能够查询区块链上每一个账户的信息及其交易记录。通过区块浏览器可验证上链信息的正确性。</p>
                <div
                  class="but"
                  @click="window.open('https://explorer.hwelltech.com/')"
                >
                  <span>咨询我们</span>
                </div>

              </div>
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="card">
              <div class="image">
                <img
                  src="../../assets/images/mobile/home/part3-8.png"
                  alt
                />
              </div>
              <div class="centent">
                <p class="title">区块链运维监控平台</p>
                <p class="line ">
                  恒为区块链运维监控平台实时监控整个区块链网络，通过可视化的方式向区块链运维人员展示了区块链节点服务器的资源状态和区块链网络的运行状态，通过异常报警机制辅助运维人员管理区块链节点，减轻了大量节点运维带来的工作量。
                </p>
                <div
                  class="but"
                  @click="$router.push('/mobile/product/operation')"
                >
                  <span>咨询我们</span>
                </div>

              </div>
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="card">
              <div class="image">
                <img
                  src="../../assets/images/mobile/home/part3-9.png"
                  alt
                />
              </div>
              <div class="centent">
                <p class="title">存证服务前置网关</p>
                <p class="line ">
                  针对区块链应用场景中大量的存证需求，存证服务前置网关封装了复杂的区块链上链接口和处理逻辑，提供了全面、灵活、便捷的存证服务，能够满足不同应用场景下，快速接入区块链实现数据上链存证的需求。
                </p>
                <div
                  class="but"
                  @click="$router.push('/mobile/product/gateway')"
                >
                  <span>咨询我们</span>
                </div>

              </div>
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="card">
              <div class="image">
                <img
                  src="../../assets/images/mobile/home/part3-10.png"
                  alt
                />
              </div>
              <div class="centent">
                <p class="title">资产数字化平台</p>
                <p class="line ">
                  恒为资产数字化平台是区块链数字资产发行的管理平台，为区块链用户提供了安全便捷的数字资产发行、查询、资产管理等功能。支持NFToken的发行，实现不同类型资产的数字化；不仅支持文字的上链，还融合IPFS实现文件的上链存储；合约编写、部署、执行简单，执行过程可跟踪；实现恒为链与其他区块链之间价值和信息的互通。
                </p>
                <div
                  class="but"
                  @click="$router.push('/mobile/product/digitization')"
                >
                  <span>咨询我们</span>
                </div>

              </div>
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="card">
              <div class="image">
                <img
                  src="../../assets/images/mobile/home/part3-11.png"
                  alt
                />
              </div>
              <div class="centent">
                <p class="title">数字资产工具包</p>
                <p class="line ">
                  恒为数字资产工具包是一个安全便捷的加密数字资产管理工具，能够帮助用户管理区块链账户及账户内的数字资产。 支持NFToken的发行，实现不同类型资产的数字化；不仅支持文字的上链，还融合IPFS实现文件的上链存储；合约编写、部署、执行简单，执行过程可跟踪；实现恒为链与其他区块链之间价值和信息的互通。
                </p>
                <div
                  class="but"
                  @click="$router.push('/mobile/product/toolkit')"
                >
                  <span>咨询我们</span>
                </div>

              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>

    <div class="part4">
      <p class="tit1">领先的区块链技术</p>
      <div class="swip">
        <van-swipe
          indicator-color="white"
          @change="onChange"
        >
          <van-swipe-item @click.native="part41 = !part41">
            <div
              class="card"
              v-show="part41 == false"
            >
              <div class="image">
                <img
                  src="../../assets/images/mobile/home/part4-1.png"
                  alt
                />
              </div>
              <div class="centent">
                <div class="title">金融+区块链</div>

                <p>区块链线上交易平台 </p>
                <p>区块链积分商城 </p>
                <p>区块链证券交易平台</p>
                <p>区块链清结算平台 </p>
                <p>区块链供应链金融平台 </p>

              </div>
            </div>
            <div
              class="bCard bCard1 "
              v-show="part41"
            >
              <p class="title">金融+区块链</p>
            </div>
          </van-swipe-item>

          <van-swipe-item @click.native="part42 = !part42">
            <div
              class="card"
              v-show="part42 == false"
            >
              <div class="image">
                <img
                  src="../../assets/images/mobile/home/part4-2.png"
                  alt
                />
              </div>
              <div class="centent">
                <div class="title">医疗+区块链</div>
                <p>区块链疫苗溯源平台 </p>
                <p>区块链处方流转平台 </p>
                <p>区块链分级诊疗平台</p>
              </div>
            </div>
            <div
              class="bCard bCard2"
              v-show="part42"
            >
              <p class="title">医疗+区块链</p>
            </div>
          </van-swipe-item>
          <van-swipe-item @click.native="part43 = !part43">
            <div
              class="card"
              v-show="part43 == false"
            >
              <div class="image">
                <img
                  src="../../assets/images/mobile/home/part4-3.png"
                  alt
                />
              </div>
              <div class="centent">
                <div class="title">农业+区块链</div>

                <p> 区块链农渔产品溯源平台 </p>

              </div>
            </div>
            <div
              class="bCard bCard3"
              v-show="part43"
            >
              <p class="title">农业+区块链</p>
            </div>
          </van-swipe-item>
          <van-swipe-item @click.native="part44 = !part44">
            <div
              class="card"
              v-show="part44 == false"
            >
              <div class="image">
                <img
                  src="../../assets/images/mobile/home/part4-4.png"
                  alt
                />
              </div>
              <div class="centent">
                <div class="title">政务+区块链</div>

                <p>区块链数据治理监管平台 </p>
                <p>区块链农村三资监管平台 </p>

              </div>
            </div>
            <div
              class="bCard bCard4"
              v-show="part44"
            >
              <p class="title">政务+区块链链</p>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>

    <div class="part5">
      <p class="tit1">{{$t('m_home.part5.tit1')}}</p>
      <div class="show">
        <div
          class="image"
          @click="window.open('https://www.armchina.com/')"
        >
          <img
            src="../../assets/images/mobile/home/part5-1.png"
            alt
          />
        </div>
        <div
          class="image"
          @click="window.open('http://www.cesi.cn/page/index.html')"
        >
          <img
            src="../../assets/images/mobile/home/part5-2.png"
            alt
          />
        </div>
        <div
          class="image"
          @click="window.open('http://www.caict.ac.cn/')"
        >
          <img
            src="../../assets/images/mobile/home/part5-3.png"
            alt
          />
        </div>
        <div
          class="image"
          @click="window.open('http://www.miitec.cn/ezweb/wcm/talent/index.jsp')"
        >
          <img
            src="../../assets/images/mobile/home/part5-4.png"
            alt
          />
        </div>

        <div
          class="image"
          @click="window.open('http://www.wx-rjxh.com/')"
        >
          <img
            src="../../assets/images/mobile/home/part5-5.png"
            alt
          />
        </div>
        <div
          class="image"
          @click="window.open('https://www.unigroup.com.cn/')"
        >
          <img
            src="../../assets/images/mobile/home/part5-6.png"
            alt
          />
        </div>
        <div
          class="image"
          @click="window.open('https://www.fudan.edu.cn/')"
        >
          <img
            src="../../assets/images/mobile/home/part5-7.png"
            alt
          />
        </div>
        <div
          class="image"
          @click="window.open('https://www.shutcm.edu.cn/')"
        >
          <img
            src="../../assets/images/mobile/home/part5-8.png"
            alt
          />
        </div>

        <div
          class="image"
          @click="window.open('https://www.nju.edu.cn/')"
        >
          <img
            src="../../assets/images/mobile/home/part5-9.png"
            alt
          />
        </div>

      </div>
      <transition name="more">
        <div
          class="show2"
          id="showMore"
        >
          <div
            class="image"
            @click="window.open('https://www.jit.edu.cn/')"
          >
            <img
              src="../../assets/images/mobile/home/part5-10.png"
              alt
            />
          </div>
          <!-- <div
            class="image"
            @click="window.open('https://www.bvcadt.com/#/')"
          >
            <img
              src="../../assets/images/mobile/home/part5-11.png"
              alt
            />
          </div> -->

          <div
            class="image"
            @click="window.open('http://www.jygb.com/')"
          >
            <img
              src="../../assets/images/mobile/home/part5-12.png"
              alt
            />
          </div>
          <div
            class="image"
            @click="window.open('http://www.newhope-data.com/')"
          >
            <img
              src="../../assets/images/mobile/home/part5-13.png"
              alt
            />
          </div>
          <div
            class="image"
            @click="window.open('http://www.chinatelecom.com.cn/')"
          >
            <img
              src="../../assets/images/mobile/home/part5-14.png"
              alt
            />
          </div>
          <div class="image">
            <img
              src="../../assets/images/mobile/home/part5-15.png"
              alt
            />
          </div>
          <div
            class="image"
            @click="window.open('http://www.cngiga.com/')"
          >
            <img
              src="../../assets/images/mobile/home/part5-16.png"
              alt
            />
          </div>

          <div
            class="image"
            @click="window.open('http://www.celefish.com/')"
          >
            <img
              src="../../assets/images/mobile/home/part5-17.png"
              alt
            />
          </div>
          <div
            class="image"
            @click="window.open('http://www.mandalat.com.cn/')"
          >
            <img
              src="../../assets/images/mobile/home/part5-18.png"
              alt
            />
          </div>
          <div
            class="image"
            @click="window.open('http://www.zgqbyp.com/')"
          >
            <img
              src="../../assets/images/mobile/home/part5-19.png"
              alt
            />
          </div>

          <div class="image">
            <img
              src="../../assets/images/mobile/home/part5-20.png"
              alt
            />
          </div>
          <div
            class="image"
            @click="window.open('http://www.svinsight.com/')"
          >
            <img
              src="../../assets/images/mobile/home/part5-21.png"
              alt
            />
          </div>
          <div
            class="image"
            @click="window.open('http://www.okdpt.com/')"
          >
            <img
              src="../../assets/images/mobile/home/part5-22.png"
              alt
            />
          </div>

          <div
            class="image"
            @click="window.open('http://www.jinzhongwei.com.cn/')"
          >
            <img
              src="../../assets/images/mobile/home/part5-23.png"
              alt
            />
          </div>
          <div
            class="image"
            @click="window.open('http://www.vortexinfo.cn/')"
          >
            <img
              src="../../assets/images/mobile/home/part5-24.png"
              alt
            />
          </div>
          <div
            class="image"
            @click="window.open('http://www.hzwhc.com/')"
          >
            <img
              src="../../assets/images/mobile/home/part5-25.png"
              alt
            />
          </div>

          <div
            class="image"
            @click="window.open('http://www.artduoduo.com.cn/')"
          >
            <img
              src="../../assets/images/mobile/home/part5-26.png"
              alt
            />
          </div>
          <!-- <div
            class="image"
            @click="window.open('http://www.idea-sf.com/')"
          >
            <img
              src="../../assets/images/mobile/home/part5-27.png"
              alt
            />
          </div>

          <div class="image">
            <img
              src="../../assets/images/mobile/home/part5-28.png"
              alt
            />
          </div> -->

        </div>
      </transition>
      <div class="btn">
        <p
          @click="  showMore('more'), part5 = !part5"
          v-show="part5"
        >
          <span>查看更多</span>
          <i class="iconfont  iconxia"></i>
        </p>
        <p
          @click="showMore('less'),part5 = !part5"
          v-show="!part5"
        >
          <span>收起</span>
          <i class="iconfont  iconshang"></i>
        </p>
      </div>
    </div>

    <div
      class="part6"
      v-if="info.id"
    >
      <p class="tit1">新闻资讯</p>
      <div
        class="card"
        @click="$router.push({path:'/mobile/newsdetail/'+info.id})"
      >
        <div class="left">
          <img
            :src="info.pic?info.pic:imgYs"
            alt=""
          >
        </div>
        <div class="right">
          <p class="title">{{info.title}}</p>
          <p class="time">时间：{{info.createdTime}}</p>
        </div>
      </div>
      <div class="btn">
        <p @click="$router.push('/mobile/newslist')">
          <span>查看更多</span>
          <i class="iconfont  iconyou"></i>
        </p>
      </div>

    </div>
    <Foot />
  </div>
</template>
<script>
import Head from "../../components/mobile/Head.vue";
import Foot from "../../components/mobile/Foot.vue";
import Vue from "vue";
import api from "../../common/api";
import { Swipe, SwipeItem } from "vant";
Vue.use(Swipe).use(SwipeItem);
export default {
  data() {
    return {
      window: window,
      part41: true, //领先的区块链技术 图片切换
      part42: true,
      part43: true,
      part44: true,
      part5: true, //合作伙伴
      rows: 1, //新闻参数
      page: 1,
      info: {
        createdTime: "",
        title: "",
        pic: "",
        id: "",
      },
      lang: localStorage.getItem("Lang"),
      imgYs:require('../../assets/images/mobile/newslist/defaultpic.png')
    };
  },
  components: {
    Head,
    Foot,
  },
  mounted() {
    this.getnewslist();
    this.goSkill(1);
  },
  methods: {
    //获取新闻
    getnewslist() {
      this.$axios
        .get(api.getReportList, {
          params: {
            rows: this.rows,
            page: this.page,
            lang: this.lang,
          },
        })
        .then((res) => {
          let list = res.data.list;

          if (list && list.length > 0) {
            this.info.createdTime = list[0].createdTime
              .substring(0, 10)
              .replace(/-/g, "/");
            this.info.title = list[0].title;
            this.info.pic = list[0].picSmall;
            this.info.id = list[0].id;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //跳转技术部分
    goSkill(type) {
      if (type == 1) {
        let hash = window.location.hash;
        let index = hash.lastIndexOf("#");
        if (index != -1) {
          document.getElementById("skill").scrollIntoView(true);
        }
      } else {
        document.getElementById("skill").scrollIntoView(true);
      }
    },

    onChange(index) {
      this.part41 = true;
      this.part42 = true;
      this.part43 = true;
      this.part44 = true;
    },

    showMore(type) {
      let show = document.getElementById("showMore");
      if (type == "more") {
        show.style.height = "101.5vw";
      } else if (type == "less") {
        show.style.height = "0";
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/css/mixin';

.wrap {
}

.part1 {
  height: vw(650);
  width: vw(750);
  margin-top: vw(97);
  padding-top: vw(245);
  bg(url('../../assets/images/mobile/home/part1.png'));

  .tit {
    margin-bottom: vw(30);
    hTit();
  }

  .txt {
    font-size: vw(24);
    color: #fff;
    line-height: vw(24);
    text-align: center;
  }
}

.part2 {
  part();
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;

  .tit1 {
    tit1();
    margin-bottom: vw(50);
  }

  .item {
    width: vw(282);
    background: rgba(255, 255, 255, 1);
    padding: vw(20) 0 0;
    margin: 0 vw(40);
    height: vw(430);

    .image {
      width: 100%;
      height: vw(193);
      text-align: center;
      margin-bottom: vw(19);

      img {
        width: vw(194);
        height: 100%;
      }
    }

    p {
      text-align: center;
    }

    .p1 {
      font-size: vw(32);
      color: rgba(68, 68, 68, 1);
      line-height: vw(32);
      margin-bottom: vw(15);
    }

    .p2 {
      font-size: vw(28);
      color: rgba(136, 136, 136, 1);
      line-height: vw(36);
    }
  }
}

.part3 {
  part();
  background: linear-gradient(0deg, #3563D9, #2A93FF);
  position: relative;
  height: vw(1267);
  padding: vw(80) 0 0 0;

  .tit1 {
    tit1();
    color: #fff;
    margin-bottom: vw(76);
  }

  .bg {
    position: absolute;
    top: vw(471);
    width: 100%;
    height: vw(393);
  }

  .swip {
    /deep/.van-swipe { // 滑动底部导航
      .van-swipe__indicators {
        .van-swipe__indicator {
          width: vw(16);
          height: vw(16);
          background-color: transparent;
          border: 1px solid #fff;
          opacity: 1;
        }
      }
    }
  }

  .card {
    width: vw(650);
    margin: 0 auto vw(80);
    border-radius: vw(10);
    background: #fff;

    .image {
      width: 100%;

      img {
        width: 100%;
        height: auto;
      }
    }

    .centent {
      padding: vw(30) vw(40) vw(56) vw(40);
      height: vw(500);
      position: relative;
      box-sizing: border-box;

      .title {
        font-size: vw(32);
        color: #444;
        line-height: vw(32);
        margin-bottom: vw(22);
        text-align: center;
      }

      .line {
        font-size: vw(24);
        color: #888888;
        line-height: vw(40);
      }

      .but {
        width: vw(570);
        position: absolute;
        bottom: vw(56);

        span {
          display: block;
          width: vw(253);
          height: vw(72);
          color: #FFFEFE;
          font-size: vw(30);
          line-height: vw(72);
          background: #FFAE00;
          border-radius: vw(36);
          margin: 0 auto;
          text-align: center;
        }
      }
    }
  }
}

.part4 {
  part();
  background: #fff;

  .tit1 {
    tit1();
    margin-bottom: vw(80);
  }

  .swip {
    /deep/.van-swipe { // 滑动底部导航
      .van-swipe__indicators {
        .van-swipe__indicator {
          width: vw(16);
          height: vw(16);
          background-color: transparent;
          border: 1px solid #2A93FF;
          opacity: 1;
        }

        .van-swipe__indicator--active {
          background: #2A93FF !important;
        }
      }
    }
  }

  .card, .bCard {
    margin: 0 auto vw(80);
    border-radius: vw(10);
    box-shadow: 0px 0px vw(20) 0px rgba(0, 0, 0, 0.4);
    padding: vw(131) 0;
    transition: all 0.3s ease;
  }

  .card {
    width: vw(650);
    height: vw(881);
    background: linear-gradient(0deg, #2E67D8, #2A93FF);

    .image {
      width: vw(140);
      height: vw(140);
      margin: 0 auto vw(80);

      img {
        width: 100%;
        height: 100%;
      }
    }

    .centent {
      height: vw(500);
      position: relative;
      box-sizing: border-box;
      text-align: center;

      .title {
        font-size: vw(36);
        font-weight: bold;
        color: #fff;
        line-height: vw(36);
        margin-bottom: vw(39);
      }

      p {
        font-size: vw(24);
        color: #fff;
        line-height: vw(24);
        margin-bottom: vw(39);
      }
    }
  }

  .bCard {
    width: vw(580);
    height: vw(812);

    .title {
      font-size: vw(36);
      font-weight: bold;
      color: #fff;
      line-height: vw(36);
      margin-top: vw(449);
      text-align: center;
    }
  }

  .bCard1 {
    bg(url('../../assets/images/mobile/home/part4-1bg.png'));
  }

  .bCard2 {
    bg(url('../../assets/images/mobile/home/part4-2bg.png'));
  }

  .bCard3 {
    bg(url('../../assets/images/mobile/home/part4-3bg.png'));
  }

  .bCard4 {
    bg(url('../../assets/images/mobile/home/part4-4bg.png'));
  }
}

.part5 {
  part();
  bg(url('../../assets/images/mobile/home/part5bg.png'));
  background-size:100% auto;
  background-position:top;

  .tit1 {
    tit1();
    margin-bottom: vw(80);
  }

  .show, .show2 {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .image {
      width: vw(209);
      height: vw(99);
      margin: 0 vw(20) vw(10);

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .show2 {
    height: 0;
    overflow: hidden;
    transition: height 0.6s ease;
  }

  .btn {
    margin-top: vw(50);

    p {
      width: vw(240);
      height: vw(80);
      background: #fff;
      border-radius: vw(40);
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
      text-align: center;
      margin: 0 auto;

      span {
        display: inline-block;
        height: vw(80);
        color: #2A93FF;
        font-size: vw(30);
        line-height: vw(80);
      }

      i {
        margin-left: vw(5);
        display: inline-block;
        height: vw(80);
        font-size: vw(24);
        color: #2A93FF;
        line-height: vw(80);
      }
    }
  }
}

.part6 {
  part();
  background: #fff;

  .tit1 {
    tit1();
    margin-bottom: vw(80);
  }

  .card {
    display: flex;
    padding: vw(44) vw(37) 0 vw(30);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    width: vw(690);
    height: vw(237);
    background: #FFFFFF;
    margin: 0 auto;

    .left {
      width: vw(200);
      margin-right: vw(30);

      img {
        width: 100%;
        height: vw(150);
      }
    }

    .right {
      flex: 1;

      .title {
        height: vw(120);
        padding-bottom: vw(14);
        font-size: vw(28);
        color: #444;
        line-height: vw(36);
        border-bottom: 1px dashed #E5E5E5;
      }

      .time {
        margin-top: vw(19);
        font-size: vw(24);
        color: #888888;
        line-height: vw(24);
      }
    }
  }

  .btn {
    margin-top: vw(50);

    p {
      width: vw(240);
      height: vw(80);
      background: #fff;
      border-radius: vw(40);
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
      text-align: center;
      margin: 0 auto;

      span {
        display: inline-block;
        height: vw(80);
        color: #2A93FF;
        font-size: vw(30);
        line-height: vw(80);
      }

      i {
        margin-left: vw(5);
        display: inline-block;
        height: vw(80);
        font-size: vw(24);
        color: #2A93FF;
        line-height: vw(80);
      }
    }
  }
}

>>>.van-swipe__indicators {
  bottom: 12px;
}
</style>
